export default "__VITE_ASSET__CIqxHfo2__"